export default __webpack_public_path__ + "static/media/DMFullColourUKTag.a4ab0c2b.svg";